import { Vue, Component } from 'vue-property-decorator';


@Component({
    name: 'usage-report',
})

export default class UsageReport extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getBackFlow() {
        this.$router.push('/dashboard');
    }
}
